import React, { useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import QuoteModal from './QuoteModal';
import { useLocation } from 'react-router-dom';
import './SiteChrome.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const location = useLocation();

  // Scroll before paint so direct refreshes and SPA navigations enter pages
  // from the same top-of-page state.
  React.useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50">
      <Navbar onOpenQuote={() => setIsQuoteOpen(true)} />
      
      <main className="flex-grow pt-[72px]">
        {children}
      </main>

      <Footer />
      
      <QuoteModal 
        isOpen={isQuoteOpen} 
        onClose={() => setIsQuoteOpen(false)} 
      />
    </div>
  );
};

export default Layout;
